export const hideOnMobileCss = theme => ({
  display: "none",

  [theme.mediaQueries.phablet]: {
    display: "block",
  },
})

export const showOnlyOnMobileCss = theme => ({
  [theme.mediaQueries.phablet]: {
    display: "none",
  },
})
